export var IdThemedEvent;
(function (IdThemedEvent) {
    IdThemedEvent[IdThemedEvent["FairyTale"] = 1] = "FairyTale";
    IdThemedEvent[IdThemedEvent["Hawaii"] = 2] = "Hawaii";
    IdThemedEvent[IdThemedEvent["Asian"] = 3] = "Asian";
    IdThemedEvent[IdThemedEvent["Camping"] = 4] = "Camping";
    IdThemedEvent[IdThemedEvent["Ufo"] = 5] = "Ufo";
    IdThemedEvent[IdThemedEvent["FoodTruck"] = 16] = "FoodTruck";
    IdThemedEvent[IdThemedEvent["FarmCup"] = 17] = "FarmCup";
    IdThemedEvent[IdThemedEvent["Halloween"] = 6] = "Halloween";
    IdThemedEvent[IdThemedEvent["Christmas"] = 9] = "Christmas";
    IdThemedEvent[IdThemedEvent["Easter"] = 14] = "Easter";
    IdThemedEvent[IdThemedEvent["Wedding"] = 62] = "Wedding";
    IdThemedEvent[IdThemedEvent["Generic"] = -1] = "Generic";
})(IdThemedEvent || (IdThemedEvent = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/IdThemedEvent.ts
// module id = 730
// module chunks = 3